export const EXPORT_FORMAT = Object.freeze({
    ZIP: {
        name: 'ZIP',
        ext: 'zip'
    },
    TIFF: {
        name: 'TIFF',
        ext: 'tiff'
    },
    // ALL: {
    //     name: 'ALL',
    //     ext: 'all'
    // }
})

export const GLOBAL_CONFIG = Object.freeze({
    EXPORT_FORMAT: {
        key: 'export_format'
    }
})

export const SAVE_STATUS = Object.freeze({
    NOT_STARTED: {
        name: 'NOT_STARTED',
        message: '',
        message_cap_report: `Edit`,
        color: `#000`,
        alpha_color: `#000`
    },
    ON_GOING: {
        name: 'ON_GOING',
        message: 'Saving',
        message_cap_report: `Saving progress...`,
        use_loader: true,
        color: `#00f`,
        alpha_color: `#ff0`
    },
    COMPLETED: {
        name: 'COMPLETED',
        message: 'Saved',
        message_cap_report: `Progress Saved`,
        color: `#37cd37`,
        alpha_color: `#37cd37`
    },
    ERROR: {
        name: 'ERROR',
        message: 'Error Saving',
        message_cap_report: `Error Saving. Please Check your internet connection.`,
        color: `#f00`,
        alpha_color: `#f00`
    }
})